var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wet-accordeon"},[_c('header',{ref:"header",staticClass:"wet-accordeon-header",class:{
      'active': _vm.open,
    },on:{"click":_vm.toggle}},[_vm._t("header")],2),_c('section',{directives:[{name:"collapse",rawName:"v-collapse",value:(_vm.open),expression:"open"}],ref:"content",staticClass:"wet-accordeon-content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }